// extracted by mini-css-extract-plugin
module.exports = {"circleBackground":"CircularProgressBar_circleBackground__Txk0z","circleProgress":"CircularProgressBar_circleProgress__2s7ZP"};